import { render, staticRenderFns } from "./SettingsConceptsDetails.vue?vue&type=template&id=3d8bd93c"
import script from "./SettingsConceptsDetails.vue?vue&type=script&lang=js"
export * from "./SettingsConceptsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports